import React, { useState, useEffect} from "react";
import { toast } from "react-toastify";
import FileViewer from "./FileViewer";
import axios from "axios";
import { PdfSvgLogo, PngSvgLogo, JpgSvgLogo, DocxSvgLogo, FileSvgLogo } from "../ReusableComponent/Common";
import styles from "./CustomerList.module.scss"
import _axios from "../../utils/api/_axios";
import { CloudDownloadOutlined, DeleteFilled, DownloadOutlined } from "@ant-design/icons";
import { Typography } from "antd";

const RenderFilesComponent = ({ fetchedFiles=[], onFileClick, onDeleteFile }) => {
  const [isPreview, setIsPreview] = useState(false);
  const [hoveredFile, setHoveredFile] = useState(null);
  const [previewFile, setPreviewFile] = useState(null);

  const handleDelete = (file, event) => {
    event.stopPropagation();
    onDeleteFile(file);
  };

  const handleMouseEnter = (file) => {
    setHoveredFile(file);
  };

  const handleMouseLeave = () => {
    setHoveredFile(null);
  };

  const handleClick = (file, event) => {
    setIsPreview(true);
    setPreviewFile(file)
  };
  const handleClose = () => {
    setIsPreview(!isPreview);
  };


  const handleDownload = (Url, name, event) => {
    event.stopPropagation();
    const fileUrl = Url;
    const filename = name;
    _axios.get(fileUrl, {
      responseType: 'blob',
    })
    .then((response) => {
      const blob = new Blob([response.data], { type: response.headers['content-type'] });
      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = filename;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(url);
    })
    .catch((error) => {
      toast.error('Error downloading file:', error);
    });
  };

  const getFileIcon = (filename) => {
    if(filename) {
      const extension = filename.split('.').pop();
      const iconMap = {
        pdf: <PdfSvgLogo />, 
        jpg: <JpgSvgLogo />,
        png: <PngSvgLogo />,
        docx: <DocxSvgLogo />
      };
  
      return iconMap[extension] || <FileSvgLogo />;
    }
  };

  return (
    <>
      {
        fetchedFiles?.message ? <Typography.Title level={5}>{fetchedFiles?.message}</Typography.Title>
        :
        <>
        {fetchedFiles?.map((file, index) => (
        <span 
          key={index}
          onClick={(event) => handleClick(file, event)}
          onMouseEnter={() => handleMouseEnter(file)}
          onMouseLeave={handleMouseLeave}
          className={styles.renderFilesComponent}
        >
          <a
            href={file?.url}
            target="_blank"
            rel="noopener noreferrer" 
          >
            {fetchedFiles && getFileIcon(file?.name)}
            <span>
              {file.name}
            </span>
          </a>
          {hoveredFile === file && (
            <>
                <CloudDownloadOutlined   onClick={(event) => handleDownload(file.url, file.name, event)} className={`fontSize22 ${styles.downloadIcon}`} />
              <DeleteFilled onClick={(event) => handleDelete(file, event)} className={` fontSize22 ${styles.cancelIcon}`} />
            </>
          )}
          {index < fetchedFiles.length - 1 ? " " : ""}
        </span>
      ))}
        </>
      }
      {/* <FileViewer 
        open={isPreview}
        handleClose={handleClose}
        previewFile={previewFile}
      /> */}
    </>
  );
};

export default RenderFilesComponent;
